import { Drawer, DrawerHeader, DrawerBody, DrawerFooter, IconButton, LoadingButton, Button, } from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import classNames from 'classnames';
import { BopisOutOfStockSurvey } from './BopisOutOfStockSurvey';
import { getWindow } from '../../../utils/general';
import { useExperienceContext } from '../../../hooks/useContexts';
export var BopisOutOfStockDrawer = function (_a) {
    var _b;
    var open = _a.open, setOpen = _a.setOpen, setDrawerError = _a.setDrawerError, orderDetailsData = _a.orderDetailsData, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, orderId = _a.orderId, customerType = _a.customerType;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _c = useState(false), isSurvey = _c[0], setIsSurvey = _c[1];
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var closeDrawer = function () {
        setOpen(false);
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-w-96" },
        React.createElement(Drawer, { open: open, onClose: closeDrawer, position: "right" },
            React.createElement(DrawerHeader, { title: "Review Your Options", endAdornment: React.createElement(IconButton, { "aria-label": "Close Review Your Options drawer", onClick: closeDrawer, icon: Close }) }),
            React.createElement(DrawerBody, null, isSurvey && (React.createElement(BopisOutOfStockSurvey, { closeDrawer: closeDrawer, fulfillmentGroup: fulfillmentGroup, orderId: orderId, fulfillmentType: fulfillmentType, orderDetailsData: orderDetailsData, customerType: customerType, setIsSurvey: setIsSurvey }))),
            React.createElement(DrawerFooter, null,
                React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2 sui-mt-8" },
                    React.createElement("div", { className: "sui-mb-2" },
                        React.createElement(LoadingButton, { style: { width: '100%' } }, "Continue")),
                    React.createElement("div", { className: classNames('card-fix', {
                            'ios-bottom-fix': isIosMobile,
                        }) },
                        React.createElement(Button, { variant: "secondary", style: { width: '100%' }, onClick: function () { return closeDrawer(); } }, "Cancel")))))));
};
